const getCustomFieldsInfo = (state) => state.customField.customFields

export default {
  getCustomFieldsInfo,
}
